import { useState } from 'react';
import React from 'react';
import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import ProfileSubNav from '../components/shared/ProfileSubNav';
import CardForm from '../components/shared/CardForm';
import { useLang } from '../i18n';
import { useGeo } from '../geo';

const FAQ_ITEMS = [
  { q: 'deposit.faq.q1', a: 'deposit.faq.a1' },
  { q: 'deposit.faq.q2', a: 'deposit.faq.a2' },
  { q: 'deposit.faq.q3', a: 'deposit.faq.a3' },
  { q: 'deposit.faq.q4', a: 'deposit.faq.a4' },
];

const API = process.env.REACT_APP_API_BASE_URL;

const css = `
  .deposit { padding: 0 16px 28px; }
  .dep-offer { position: relative; height: 82px; border-radius: 12px; overflow: hidden; margin-top: 6px; }
  .dep-offer-bg { position: absolute; inset: 0; background-size: cover; background-position: 60% 40%; }
  .dep-offer-bg::after { content: ""; position: absolute; inset: 0; background: linear-gradient(90deg, rgba(16,14,38,.94) 36%, rgba(16,14,38,.15) 80%); }
  .dep-offer-c { position: relative; height: 100%; padding: 0 16px; display: flex; flex-direction: column; justify-content: center; }
  .dep-offer-tag { font-size: 10px; font-weight: 800; letter-spacing: .6px; color: #76e1ff; }
  .dep-offer-main { font-size: 14px; font-weight: 800; color: #fff; margin-top: 4px; }
  .dep-offer-main b { background: linear-gradient(90deg, #8187f6, #76e1ff); -webkit-background-clip: text; background-clip: text; color: transparent; }
  .dep-x3 { position: absolute; top: 10px; right: 10px; height: 22px; padding: 0 10px; border-radius: 11px; background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; font-size: 13px; font-weight: 800; display: grid; place-items: center; }
  .dep-card { margin-top: 12px; padding: 12px; border-radius: 12px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.07); }
  .dep-label { font-size: 11px; color: #9b9ab0; font-weight: 600; margin-bottom: 9px; }
  .dep-input { display: flex; align-items: center; gap: 9px; height: 50px; background: #100e26; border-radius: 10px; box-shadow: inset 0 0 0 1px rgba(255,255,255,.08); padding: 0 14px; transition: box-shadow .15s; }
  .dep-input:focus-within { box-shadow: inset 0 0 0 1px #76e1ff; }
  .dep-cur { font-size: 18px; color: #76e1ff; font-weight: 700; }
  .dep-amount { flex: 1; background: none; border: none; outline: none; color: #fff; font-size: 20px; font-weight: 700; font-family: inherit; width: 100%; }
  .dep-amount::placeholder { color: #46455e; }
  .dep-quick { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 10px; }
  .dep-chip { height: 34px; border-radius: 8px; background: #1d1c3c; color: #cfcee0; font-size: 12px; font-weight: 600; }
  .dep-chip.on { background: rgba(118,225,255,.12); box-shadow: inset 0 0 0 1px #76e1ff; color: #fff; }
  .dep-tabs { display: flex; gap: 6px; margin-top: 14px; background: #16142e; border-radius: 11px; padding: 4px; }
  .dep-tab { flex: 1; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; gap: 6px; color: #9b9ab0; font-size: 12px; font-weight: 700; }
  .dep-tab.on { background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; }
  .dep-methods { display: flex; flex-direction: column; gap: 8px; margin-top: 12px; }
  .dep-row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .dep-method { height: 48px; border-radius: 10px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.08); display: flex; align-items: center; justify-content: center; gap: 8px; color: #fff; font-size: 13px; font-weight: 700; position: relative; cursor: pointer; }
  .dep-method.on { box-shadow: inset 0 0 0 1.5px #76e1ff; background: rgba(118,225,255,.08); }
  .dep-cardnum { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; border-radius: 6px; background: #100e26; box-shadow: inset 0 0 0 1px rgba(255,255,255,.1); display: grid; place-items: center; font-size: 11px; color: #9b9ab0; }
  .dep-method.on .dep-cardnum { color: #76e1ff; box-shadow: inset 0 0 0 1px #76e1ff; }
  .pay-visa { font-style: italic; font-weight: 800; font-size: 17px; letter-spacing: .5px; }
  .mc { display: inline-flex; }
  .mc i { width: 16px; height: 16px; border-radius: 50%; display: block; }
  .mc .r { background: #eb001b; } .mc .y { background: #f79e1b; margin-left: -7px; mix-blend-mode: screen; }
  .dep-notification { position: fixed; top: 80px; right: 20px; background: #ff4757; color: white; padding: 12px 24px; border-radius: 8px; font-size: 14px; font-weight: 600; z-index: 1000; box-shadow: 0 4px 12px rgba(255,71,87,0.3); opacity: 1; transition: opacity 0.2s; }
  @keyframes slideDown { from { opacity: 0; transform: translate(-50%, -20px); } to { opacity: 1; transform: translate(-50%, 0); } }
  .dep-summary { margin-top: 14px; padding-top: 12px; box-shadow: inset 0 1px 0 rgba(255,255,255,.07); }
  .dep-srow { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 5px 2px; }
  .dep-srow .k { color: #9b9ab0; font-size: 12px; }
  .dep-srow .v { color: #fff; font-size: 13px; }
  .dep-srow.total .k { font-weight: 800; color: #fff; font-size: 14px; }
  .dep-srow.total .v { font-weight: 800; font-size: 15px; color: #76e1ff; }
  .dep-proceed { display: flex; align-items: center; justify-content: center; gap: 8px; height: 46px; border-radius: 11px; margin-top: 14px; width: 100%; background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; font-size: 15px; font-weight: 700; cursor: pointer; border: none; font-family: inherit; }
  .dep-proceed.off { background: #1d1c3c; color: #5a5972; pointer-events: none; }
  .dep-proceed:disabled { cursor: default; opacity: .85; }
  .dep-spin { animation: dep-rot .7s linear infinite; }
  @keyframes dep-rot { to { transform: rotate(360deg); } }
  .dep-faq { margin-top: 20px; }
  .dep-faq-title { font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 10px; }
  .dep-faq-item { border-radius: 10px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.07); margin-bottom: 6px; overflow: hidden; }
  .dep-faq-q { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 12px 14px; font-size: 13px; font-weight: 600; color: #cfcee0; text-align: left; background: none; border: none; cursor: pointer; font-family: inherit; }
  .dep-faq-q svg { flex: none; transition: transform .2s; }
  .dep-faq-item.open .dep-faq-q svg { transform: rotate(180deg); }
  .dep-faq-a { display: none; padding: 0 14px 12px; font-size: 12px; color: #9b9ab0; line-height: 1.6; }
  .dep-faq-item.open .dep-faq-a { display: block; }
`;

function Apple() {
  return <svg width="17" height="19" viewBox="0 0 16 18" fill="currentColor"><path d="M13 9.6c0-2 1.6-2.9 1.7-3-1-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7-.6 0-1.6-.7-2.6-.7C5 5 3.8 5.8 3.1 7c-1.3 2.3-.3 5.7 1 7.6.6.9 1.4 1.9 2.4 1.9 1 0 1.3-.6 2.5-.6 1.1 0 1.5.6 2.5.6s1.7-.9 2.3-1.8c.7-1 1-2 1-2-.1 0-2-.8-2-3.1zM11 3.7c.5-.7.9-1.6.8-2.6-.8 0-1.8.6-2.4 1.2-.5.6-1 1.5-.8 2.4.9.1 1.8-.4 2.4-1z" /></svg>;
}
function GoogleG() {
  return <svg width="17" height="17" viewBox="0 0 18 18"><path fill="#4285F4" d="M17.6 9.2c0-.6 0-1.1-.2-1.7H9v3.3h4.8a4.1 4.1 0 01-1.8 2.7v2.2h2.9c1.7-1.6 2.7-3.9 2.7-6.5z"/><path fill="#34A853" d="M9 18c2.4 0 4.5-.8 6-2.2l-2.9-2.2c-.8.5-1.8.9-3.1.9-2.4 0-4.4-1.6-5.1-3.8H.9v2.3A9 9 0 009 18z"/><path fill="#FBBC05" d="M3.9 10.7a5.4 5.4 0 010-3.4V5H.9a9 9 0 000 8z"/><path fill="#EA4335" d="M9 3.6c1.3 0 2.5.5 3.4 1.3l2.6-2.6A9 9 0 00.9 5l3 2.3C4.6 5.2 6.6 3.6 9 3.6z"/></svg>;
}
function Mc() { return <span className="mc"><i className="r" /><i className="y" /></span>; }
function Cr({ sym, color }) {
  return <span style={{ width: 22, height: 22, borderRadius: '50%', background: color, color: '#fff', display: 'grid', placeItems: 'center', fontSize: 13, fontWeight: 800 }}>{sym}</span>;
}

const TAB_ICONS = {
  mobile: <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="4" y="1.5" width="8" height="13" rx="2" stroke="currentColor" strokeWidth="1.3" /><path d="M7 12.5h2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>,
  carte:  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1.5" y="3.5" width="13" height="9" rx="2" stroke="currentColor" strokeWidth="1.3" /><path d="M1.5 6.5h13" stroke="currentColor" strokeWidth="1.3" /></svg>,
  bank:   <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 13h12M3 6v5M6 6v5M10 6v5M13 6v5M1 6h14M8 1.5l7 4H1z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  crypto: <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.3" /><path d="M6 5h3a1.6 1.6 0 010 3.2H6zm0 3.2h3.3a1.6 1.6 0 010 3.2H6zM7.5 3.7v1.3M7.5 11.4v1.3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>,
};

export default function Deposit() {
  const { t } = useLang();
  const geo  = useGeo();
  const [amount, setAmount] = useState('');
  const [openFaq, setOpenFaq] = useState(null);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  // Charger les informations utilisateur
  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
    setIsLoading(false);
  }, []);

  // Afrique & LATAM : le moyen local (bank) reste l'onglet focus ; la carte USD
  // ne passe en principal que si aucun moyen local n'est dispo (bank absent).
  const TAB_ORDER  = (geo.zone === 'latam' || geo.zone === 'africa')
    ? ['bank', 'carte', 'mobile', 'crypto']
    : ['carte', 'mobile', 'bank', 'crypto'];
  const defaultTab = TAB_ORDER.find(id => geo.tabs.includes(id)) || 'carte';
  const [submitting, setSubmitting] = useState(false);
  const [tab, setTab]   = useState(defaultTab);
  const defaultMethod = geo.methods[defaultTab]?.[0]?.id || '';
  const [method, setMethod] = useState(defaultMethod);
  const num = parseFloat(amount) || 0;
  const { symbol, presets } = geo.prices;
  const fmt = (n) => n.toFixed(2) + ' ' + symbol;

  // Onglet « Carte » avec checkout maison (MoneyEUR_BP) → formulaire carte inline
  // (collecte + appel API Payou serveur) au lieu des boutons de méthode + SCI.
  const isCustomCard = tab === 'carte' && geo.methodCheckout(method) === 'card';

  // Montants minimums par méthode — EXPRIMÉS EN EUR (base), convertis en devise
  // locale dans getMinimumAmount(). ⚠️ Ne PAS remettre de valeurs brutes ici :
  // sans conversion, "35" valait 35 unités locales (ex. 35 XOF ≈ 0,05 €), ce qui
  // laissait passer des dépôts de 0,91 € sur les devises à fort taux.
  const MINIMUM_AMOUNTS_EUR = {
    applepay: 50,
    gpay: 50,
    'money-eur-bp': 20,
    'bank-eur': 50,
    'bank-usd': 10,     // Équateur (Deuna) : 10 € (~12 USD)
    // défaut 35 € pour tout le reste (visa/visa2/crypto/revolut/blik…)
  };

  // Arrondi vers le HAUT (ne descend jamais sous le plancher EUR voulu).
  const roundMinLocal = (n) => {
    if (n < 100) return Math.ceil(n);
    const mag = Math.pow(10, Math.floor(Math.log10(n)) - 1);
    return Math.ceil(n / mag) * mag;
  };

  // Montant minimum pour la méthode sélectionnée, en devise locale.
  const getMinimumAmount = () => {
    // ARS : plancher Payou spécifique (~11 €), au-dessus des 10 € uniformes.
    if (geo.currency === 'ARS') return 20000;
    // Afrique : dépôt min 15 € pour TOUS les pays, converti en devise locale.
    if (geo.zone === 'africa') return roundMinLocal(15 * (geo.prices.rate || 1));
    // LATAM : dépôt min 10 € pour TOUS les pays, converti en devise locale.
    if (geo.zone === 'latam') return roundMinLocal(10 * (geo.prices.rate || 1));
    // Autres (Europe, US…) : minimum par méthode (base EUR convertie).
    const baseEur = MINIMUM_AMOUNTS_EUR[method] ?? 35;
    return roundMinLocal(baseEur * (geo.prices.rate || 1));
  };

  // Filtrer les presets pour afficher uniquement ceux au-dessus du minimum
  const filteredPresets = presets.filter(preset => preset >= getMinimumAmount());

  // Vérifier si le montant est suffisant
  const isAmountValid = num >= getMinimumAmount();

  // Message pour le minimum
  const getMinimumMessage = () => {
    const amount = getMinimumAmount().toLocaleString();
    return t('deposit.minMethod', { amount, symbol });
  };

  // Vérifier si on doit afficher l'offre de premier dépôt
  const showFirstDepositOffer = user && user.step_withdrawal <= 1;

  const handleDeposit = async () => {
    if (submitting) return; // anti double-clic
    if (num <= 0) {
      setNotificationMessage(t('deposit.invalidAmount'));
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 4500);
      return;
    }

    if (!isAmountValid) {
      setNotificationMessage(getMinimumMessage());
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 4500);
      return;
    }

    setSubmitting(true);
    const paysys   = geo.paysys[method] || method;
    const currency = geo.methodCurrency(method);
    const gateway  = geo.methodGateway(method);
    const summ     = geo.payAmount(method, num).toFixed(2);
    const userId   = user?.id || 0;
    const email    = user?.email || '';

    try {
      const res = await fetch(`${API}/api/payments/sign.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ summ, paysys, currency, prefix: '', gateway, user_id: userId, email }),
      });
      const d = await res.json();
      if (!d || !d.success) { setSubmitting(false); return; }

      let url;
      if (d.gateway === 'payou') {
        url = `https://payou.pro/sci/v1/?id=${d.id}&sistems=${d.sistems}&summ=${d.summ}&order_id=${d.order_id}&hash=${d.hash}&user_code=${d.user_code}&user_email=${d.email}`;
      } else {
        const base = window.location.origin;
        url = `https://kassify.com/sci/?ids=${d.ids}&summ=${d.summ}&s=${d.s}&us_id=${d.us_id}&user_code=${d.user_code}&paysys=${d.paysys}&url_success=${encodeURIComponent(base + '/payment/success')}&url_fail=${encodeURIComponent(base + '/payment/failed')}`;
      }
      window.location.href = url;
    } catch {
      /* erreur réseau : on n'effectue pas la redirection */
      setSubmitting(false);
    }
  };

  function renderIcon(m) {
    switch (m.icon) {
      case 'apple':   return <Apple />;
      case 'google':  return <GoogleG />;
      case 'visa_mc': return <><span className="pay-visa">VISA</span><Mc /></>;
      case 'btc':     return <Cr sym="₿" color="#f7931a" />;
      case 'eth':     return <Cr sym="Ξ" color="#627eea" />;
      case 'usdt':    return <Cr sym="₮" color="#26a17b" />;
      case 'ltc':     return <Cr sym="Ł" color="#345d9d" />;
      case 'revolut': return null;
      case 'blik':    return <span style={{ background: '#e2001a', color: '#fff', fontWeight: 800, fontSize: 13, borderRadius: 5, padding: '2px 6px', letterSpacing: '.5px' }}>blik</span>;
      case 'pix':     return <img src="/img/pix.svg" alt="Pix" style={{ height: 20, width: 'auto', display: 'block' }} />;
      case 'mercadopago': return <img src="/img/mercadopago.svg" alt="Mercado Pago" style={{ height: 20, width: 'auto', display: 'block' }} />;
      case 'deuna':   return <img src="/img/deuna.svg" alt="Deuna" style={{ height: 22, width: 22, borderRadius: 6, display: 'block' }} />;
      case 'pagomovil': return <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="4" y="1.5" width="8" height="13" rx="2" stroke="currentColor" strokeWidth="1.3" /><path d="M7 12.5h2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>;
      case 'bank':    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 13h12M3 6v5M6 6v5M10 6v5M13 6v5M1 6h14M8 1.5l7 4H1z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
      default:        return null;
    }
  }

  function renderMethods(list) {
    const rows = [];
    for (let i = 0; i < list.length; i += 2) {
      const pair = list.slice(i, i + 2);
      const btn  = (m) => (
        <button key={m.id} className={'dep-method' + (method === m.id ? ' on' : '')} onClick={() => setMethod(m.id)}>
          {renderIcon(m)}
          {m.label    && <span>{m.label}</span>}
          {m.cardnum != null && <span className="dep-cardnum">{m.cardnum}</span>}
        </button>
      );
      if (pair.length === 2) {
        rows.push(<div key={i} className="dep-row2">{pair.map(btn)}</div>);
      } else {
        rows.push(btn(pair[0]));
      }
    }
    return rows;
  }

  return (
    <PhoneShell activeTab="">
      <style>{css}</style>
      <BackHeader title={t('deposit.title')} />
      <ProfileSubNav />

      {/* Notification */}
      {showNotification && (
        <div className="dep-notification" style={{ top: '80px', right: '16px', left: 'auto', transform: 'none' }}>
          {notificationMessage}
        </div>
      )}

      <div className="deposit">
        {showFirstDepositOffer && !isLoading && (
          <div className="dep-offer">
            <div className="dep-offer-bg" style={{ backgroundImage: 'url(/img/home-banner.png)' }} />
            <div className="dep-offer-c">
              <div className="dep-offer-tag">{t('deposit.offerTag')}</div>
              <div className="dep-offer-main">{t('deposit.offerMain')}</div>
            </div>
            <span className="dep-x3">×3</span>
          </div>
        )}

        <div className="dep-card">
          <div className="dep-label">{t('deposit.amountLabel')}</div>
          <div className="dep-input">
            <span className="dep-cur">{symbol}</span>
            <input
              className="dep-amount"
              inputMode="decimal"
              placeholder="0.00"
              value={amount}
              onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))}
            />
          </div>
          <div className="dep-quick">
            {filteredPresets.map((v) => (
              <button key={v} className={'dep-chip' + (num === v ? ' on' : '')} onClick={() => setAmount(String(v))}>{String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</button>
            ))}
          </div>
        </div>

        <div className="dep-tabs">
          {[['mobile', t('deposit.tabMobile')], ['bank', t('deposit.tabBank')], ['carte', t('deposit.tabCard')], ['crypto', t('deposit.tabCrypto')]]
            .filter(([id]) => geo.tabs.includes(id))
            .map(([id, label]) => (
              <button key={id} className={'dep-tab' + (tab === id ? ' on' : '')} onClick={() => { setTab(id); setMethod(geo.methods[id]?.[0]?.id || ''); }}>
                {TAB_ICONS[id]} {label}
              </button>
            ))}
        </div>

        {!isCustomCard && (
          <div className="dep-methods">
            {renderMethods(geo.methods[tab] || [])}
          </div>
        )}

        {!isCustomCard && (
          <div className="dep-summary">
            <div className="dep-srow"><span className="k">{t('deposit.amount')}</span><span className="v">{fmt(num)}</span></div>
            <div className="dep-srow total"><span className="k">{t('deposit.totalCredited')}</span><span className="v">{fmt(showFirstDepositOffer ? num * 3 : num)}</span></div>
          </div>
        )}

        {isCustomCard ? (
          <CardForm
            summ={geo.payAmount(method, num).toFixed(2)}
            currency={geo.methodCurrency(method)}
            paysys={geo.paysys[method] || method}
            prefix=""
            detectedCC={geo.country}
            payLabel={fmt(num)}
            amountLabel={fmt(num)}
            creditedLabel={fmt(showFirstDepositOffer ? num * 3 : num)}
            amountValid={isAmountValid && num > 0}
            minMessage={getMinimumMessage()}
          />
        ) : (
          <button className={'dep-proceed' + (num <= 0 ? ' off' : '')} onClick={handleDeposit} disabled={num <= 0 || submitting}>
            {submitting ? (
              <svg className="dep-spin" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.2" stroke="currentColor" strokeOpacity="0.3" strokeWidth="1.8" /><path d="M8 1.8a6.2 6.2 0 016.2 6.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
            ) : (
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none"><rect x="2.5" y="6.5" width="9" height="6.5" rx="1.6" stroke="currentColor" strokeWidth="1.3" /><path d="M4.5 6.5V4.7a2.5 2.5 0 015 0v1.8" stroke="currentColor" strokeWidth="1.3" /></svg>
            )}
            {submitting ? t('deposit.processing') : t('deposit.proceed')}
          </button>
        )}

        <div className="dep-faq">
          <div className="dep-faq-title">{t('deposit.faqTitle')}</div>
          {FAQ_ITEMS.map((item, i) => (
            <div key={i} className={'dep-faq-item' + (openFaq === i ? ' open' : '')}>
              <button className="dep-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{t(item.q)}</span>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 5l4 4 4-4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
              </button>
              <div className="dep-faq-a">{t(item.a)}</div>
            </div>
          ))}
        </div>
      </div>
    </PhoneShell>
  );
}
